import { render, staticRenderFns } from "./ClubDeGolf.vue?vue&type=template&id=01542a06"
import script from "./ClubDeGolf.vue?vue&type=script&lang=js"
export * from "./ClubDeGolf.vue?vue&type=script&lang=js"
import style0 from "./ClubDeGolf.vue?vue&type=style&index=0&id=01542a06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports